import { AuthenticationResult, InteractionRequiredAuthError } from '@azure/msal-browser';
import { accessTokenRequest, msalInstance } from '../../../modules/auth';
import { AuthErrorInstance } from './classes/AuthErrorInstance';

const accessToken = () => {
    const accessTokenRequestFullRequest = {
        ...accessTokenRequest,
    };
    const handelErrorAccessToken = async (error: any) => {
        if (error instanceof InteractionRequiredAuthError && !AuthErrorInstance.getInstance().isRedirected) {
            AuthErrorInstance.getInstance().setIsRedirected(true);
            msalInstance.setActiveAccount(null);
            await msalInstance.acquireTokenRedirect(accessTokenRequestFullRequest);
        }

        if (msalInstance.getAllAccounts().length == 0) {
            //if account was logout from one tab, on the others, when we got error on msal account, relogin for gain access
            msalInstance.loginRedirect();
        }
    };

    const getAcquireTokenSilent = async (): Promise<AuthenticationResult> => {
        return (await msalInstance.acquireTokenSilent(accessTokenRequestFullRequest).catch(async (error) => {
            await handelErrorAccessToken(error);
        })) as AuthenticationResult;
    };

    const getSSOSilent = async (): Promise<AuthenticationResult> => {
        return (await msalInstance.ssoSilent(accessTokenRequestFullRequest).catch(async (error) => {
            await handelErrorAccessToken(error);
        })) as AuthenticationResult;
    };

    return { getAcquireTokenSilent, getSSOSilent, handelErrorAccessToken };
};

export default accessToken;
